export default API => ({
  stuSave({ params, data }) {
      return API({ url: '/order/v1/evaluation/stu/save', method:'post', params, data });
  },
  findByOrderNo(params) {
      return API({
        url: '/order/v1/evaluation/stu/findByOrderNo',
        mathod: 'get',
        params
      })
  },
})
